/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

import type { UniversalClinicActionStatus } from "./UniversalClinicActionStatus";
import type { UniversalClinicActions } from "./UniversalClinicActions";

export interface UniversalClinicRequirement {
  action: UniversalClinicActions;
  status: UniversalClinicActionStatus;
}
